module.exports = __webpack_public_path__ + "img/1482469402.d5a879be.jpg";